import { render, staticRenderFns } from "./Cidade.vue?vue&type=template&id=148b7227"
import script from "./Cidade.vue?vue&type=script&lang=js"
export * from "./Cidade.vue?vue&type=script&lang=js"
import style0 from "./Cidade.vue?vue&type=style&index=0&id=148b7227&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports